import React from 'react';

function LeagueSelector({ sport, activeLeague, onChange }) {
  if (!sport || !sport.has_leagues || !sport.leagues || sport.leagues.length === 0) {
    return null;
  }

  const allLeagues = sport.leagues;

  // Separate leagues by category (for tennis: atp vs wta vs challenger)
  const atpLeagues = allLeagues.filter(l => l.category === 'atp' || l.category === 'main');
  const wtaLeagues = allLeagues.filter(l => l.category === 'wta');
  const challenger = allLeagues.filter(l => l.category === 'challenger');
  const hasCategorized = atpLeagues.length > 0 || wtaLeagues.length > 0 || challenger.length > 0;

  const leagueLabel = (league) =>
    league.active === false ? `${league.title} (No odds)` : league.title;

  return (
    <div className="league-selector">
      <select
        value={activeLeague || ''}
        onChange={(e) => onChange(e.target.value || null)}
      >
        <option value="">All {sport.name}</option>
        {hasCategorized ? (
          <>
            {atpLeagues.length > 0 && (
              <optgroup label="ATP">
                {atpLeagues.map(league => (
                  <option key={league.key} value={league.key} className={league.active === false ? 'inactive-league' : ''}>
                    {leagueLabel(league)}
                  </option>
                ))}
              </optgroup>
            )}
            {wtaLeagues.length > 0 && (
              <optgroup label="WTA">
                {wtaLeagues.map(league => (
                  <option key={league.key} value={league.key} className={league.active === false ? 'inactive-league' : ''}>
                    {leagueLabel(league)}
                  </option>
                ))}
              </optgroup>
            )}
            {challenger.length > 0 && (
              <optgroup label="Challenger / ITF">
                {challenger.map(league => (
                  <option key={league.key} value={league.key} className={league.active === false ? 'inactive-league' : ''}>
                    {leagueLabel(league)}
                  </option>
                ))}
              </optgroup>
            )}
          </>
        ) : (
          allLeagues.map(league => (
            <option key={league.key} value={league.key} className={league.active === false ? 'inactive-league' : ''}>
              {leagueLabel(league)}
            </option>
          ))
        )}
      </select>
    </div>
  );
}

export default LeagueSelector;
